// extracted by mini-css-extract-plugin
export default {"Box":"AddSubIssueButtonGroup-module__Box--Vv1Xr"};